import React from 'react';

const MAX_APPEARENCES = 3;

const SESSION_IS_CONFIRMED_KEY = 's-calc-ref-c';
const COUNT_SHOWN_KEY = 'l-calc-ref-count-s';

const getIsConfirmed = () => 'true' === sessionStorage.getItem(SESSION_IS_CONFIRMED_KEY);
const setIsConfirmed = () => {
    sessionStorage.setItem(SESSION_IS_CONFIRMED_KEY, 'true');
};

const getCountShown = () => {
    const parsedNumber = parseInt(localStorage.getItem(COUNT_SHOWN_KEY));
    if (Number.isNaN(parsedNumber)) {
        return 0;
    }
    return parsedNumber;
};
const incrementCountShown = () => {
    const count = getCountShown();
    if (count < MAX_APPEARENCES) {
        localStorage.setItem(COUNT_SHOWN_KEY, String(count + 1));
    }
};

export function useCalculatedRefundWarning(onSelectionChange: (newSelection: Set<string>) => void) {
    const [open, setOpen] = React.useState(false);
    const [pendingState, setPendingState] = React.useState<Set<string>>();
    const handleSelectionChange = React.useCallback(
        (newSelection: Set<string>) => {
            if (!getIsConfirmed() && getCountShown() < MAX_APPEARENCES) {
                setPendingState(newSelection);
                setOpen(true);
            } else {
                onSelectionChange(newSelection);
            }
        },
        [onSelectionChange]
    );
    const handleCofirmSelection = React.useCallback(() => {
        setOpen(false);
        onSelectionChange(pendingState);
        setIsConfirmed();
        incrementCountShown();
        setPendingState(undefined);
    }, [onSelectionChange, pendingState]);
    const handleDiscardSelectionChange = React.useCallback(() => {
        setOpen(false);
        setPendingState(undefined);
    }, []);
    return {
        open,
        onBridgeSelectionChange: handleSelectionChange,
        onCofirmSelection: handleCofirmSelection,
        onDiscardSelection: handleDiscardSelectionChange
    };
}
